import React, { useEffect, useRef, useState } from "react";
import TextFieldGroup from "../../commons/TextFieldGroup";
import Searchbar from "../../commons/Searchbar";
import axios from "axios";
import {
  Layout,
  Breadcrumb,
  Form,
  Table,
  Divider,
  Icon,
  Row,
  Col,
  Input,
  Checkbox,
  message,
} from "antd";

import { formItemLayout, tailFormItemLayout } from "./../../utils/Layouts";
import { EditOutlined, CloseOutlined } from "@ant-design/icons";
import isEmpty from "../../validation/is-empty";
import { useSelector } from "react-redux";
import {
  edit,
  onDelete,
  onSubmit,
  onSearch,
  onChange,
  onDeleteItem,
} from "../../utils/form_utilities";
import moment from "moment";
import DatePickerFieldGroup from "../../commons/DatePickerFieldGroup";
import numberFormat from "../../utils/numberFormat";
import { authenticateAdmin } from "../../utils/authentications";
import SelectFieldGroup from "../../commons/SelectFieldGroup";

import CheckboxFieldGroup from "../../commons/CheckboxFieldGroup";
import { category_type_options } from "../../utils/Options";
import SimpleSelectFieldGroup from "../../commons/SimpleSelectFieldGroup";
import {
  onCondimentsSearch,
  addKeysToArray,
  onBranchSearch,
  onWarehouseSearch,
} from "../../utils/utilities";
import SelectTagFieldGroup from "../../commons/SelectTagsFieldGroup";

const { Content } = Layout;

const url = "/api/printer-stations/";
const title = "Printer Station Form";

const initialValues = {
  _id: null,
  name: "",
  condiments: [],
  not_in_menu: false,
  is_for_walkin_only: false,
  is_promo_items: false,
  category_type: null,
  sequence: "",
};

const initialItemValues = {
  stock: null,
};

const date_fields = [];
export default function PrinterStationForm({ history }) {
  const [errors, setErrors] = useState({});
  const [records, setRecords] = useState([]);
  const [total_records, setTotalRecords] = useState(null);
  const [current_page, setCurrentPage] = useState(1);
  const [search_keyword, setSearchKeyword] = useState("");
  const auth = useSelector((state) => state.auth);

  const [state, setState] = useState(initialValues);
  const [item, setItem] = useState(initialItemValues);

  const condimentField = useRef(null);
  const addItemButton = useRef(null);
  const [options, setOptions] = useState({
    condiments: [],
  });

  const records_column = [
    {
      title: "Name",
      dataIndex: "name",
    },
    /* {
      title: "Seq",
      dataIndex: "sequence",
      align: "center",
      width: 100,
      render: (value, record) => (
        <Input
          defaultValue={value}
          className="table-input-sequence"
          onBlur={(e) => {
            axios
              .post(`/api/subcategories/${record._id}/sequence`, {
                sequence: e.target.value,
              })
              .then(() => message.success(`${record.name} sequence updated`))
              .catch((err) => console.log(err));
          }}
        />
      ),
    }, */

    {
      title: "",
      key: "action",
      width: 10,
      render: (text, record) => (
        <span
          onClick={() =>
            edit({
              record,
              setErrors,
              setRecords,
              url,
              setState,
            })
          }
        >
          <i className="fas fa-edit"></i>
        </span>
      ),
    },
  ];

  useEffect(() => {
    authenticateAdmin({
      role: auth.user?.role,
      history,
    });
    return () => {};
  }, []);

  return (
    <Content className="content-padding">
      <div className="columns is-marginless">
        <div className="column">
          <Breadcrumb style={{ margin: "16px 0" }}>
            <Breadcrumb.Item>Home</Breadcrumb.Item>
            <Breadcrumb.Item>{title}</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <div className="column">
          <Searchbar
            name="search_keyword"
            onSearch={(value, e) => {
              e.preventDefault();
              onSearch({
                page: 1,
                search_keyword,
                url,
                setRecords,
                setTotalRecords,
                setCurrentPage,
                setErrors,
              });
            }}
            onChange={(e) => setSearchKeyword(e.target.value)}
            value={search_keyword}
            onNew={() => {
              setRecords([]);
              setState(initialValues);
            }}
          />
        </div>
      </div>

      <div style={{ background: "#fff", padding: 24, minHeight: 280 }}>
        <span className="module-title">{title}</span>
        <Divider />
        {isEmpty(records) ? (
          <Form
            onFinish={() => {
              onSubmit({
                values: {
                  ...state,
                },
                auth,
                url,
                setErrors,
                setState,
                date_fields,
              });
            }}
            initialValues={initialValues}
          >
            <TextFieldGroup
              label="Name"
              name="name"
              error={errors.name}
              formItemLayout={formItemLayout}
              value={state.name}
              onChange={(e) => {
                onChange({
                  key: e.target.name,
                  value: e.target.value,
                  setState,
                });
              }}
            />

            {/* <TextFieldGroup
              label="Sequence"
              name="sequence"
              error={errors.sequence}
              formItemLayout={formItemLayout}
              value={state.sequence}
              onChange={(e) => {
                onChange({
                  key: e.target.name,
                  value: e.target.value,
                  setState,
                });
              }}
            /> */}

            <Form.Item {...tailFormItemLayout}>
              <div className="field is-grouped m-t-1">
                <div className="control">
                  <button className="button is-small is-primary">Save</button>
                </div>
                {!isEmpty(state._id) ? (
                  <span
                    className="button is-danger is-outlined is-small"
                    onClick={() => {
                      onDelete({
                        id: state._id,
                        url,
                        user: auth.user,
                      });
                      setState(initialValues);
                    }}
                  >
                    <span>Delete</span>
                    <span>
                      <i className="fas fa-times"></i>
                    </span>
                  </span>
                ) : null}
              </div>
            </Form.Item>
          </Form>
        ) : (
          <Table
            dataSource={records}
            columns={records_column}
            rowKey={(record) => record._id}
            pagination={false}
          />
        )}
      </div>
    </Content>
  );
}
